import React from 'react';

import { DARK_SPOTS, INGREDIENTS } from './ingredients-info';
import type { IngredientsProps } from '../Ingredients';

export const INGREDIENTS_DARK_SPOT_FORMULA_CONTENT: IngredientsProps = {
  header: (
    <React.Fragment>
      Prescription ingredients,
      <br /> picked for your skin
    </React.Fragment>
  ),
  ingredients: INGREDIENTS[DARK_SPOTS],
};
